<template>
  <v-app-bar id="home-nav-bar" app color="#eeeeee" height="75" elevation="1">
    <v-container class="nav-wrapper">
      <!-- LEFT: LOGO -->
      <div class="left-section">
        <v-img
          src="@/assets/joan-logo1.jpeg"
          contain
          max-width="70"
          class="logo"
        />
      </div>

      <!-- MOBILE RIGHT TEXT -->
      <div class="mobile-text">
        <div>+65 8068 8811 / +65 8812 0772</div>
        <div>contact@joanrecruit.com</div>
        <div>License No: 95C8957</div>
      </div>

      <!-- DESKTOP TEXT -->
      <div class="desktop-text">
        <div class="item">
          <v-icon size="18" color="red">mdi-phone</v-icon>
          <span>+65 8068 8811 / +65 8812 0772</span>
        </div>

        <div class="item">
          <v-icon size="18" color="red">mdi-email</v-icon>
          <span>contact@joanrecruit.com</span>
        </div>

        <div class="item">
          <v-icon size="18" color="red">
            mdi-card-account-details-outline
          </v-icon>
          <span>License No: 95C8957</span>
        </div>
      </div>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "HomeNavBar",
};
</script>

<style scoped>
/* MAIN WRAPPER */
.nav-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* LEFT LOGO */
.left-section {
  display: flex;
  align-items: center;
}

/* LOGO */
.logo {
  max-width: 70px;
}

/* DESKTOP TEXT */
.desktop-text {
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 16px;
  font-weight: bold;
}

/* EACH ITEM */
.item {
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
}

/* MOBILE TEXT (RIGHT SIDE) */
.mobile-text {
  display: none;
  font-size: 13px;
  line-height: 1.3;
  font-weight: bold;
  text-align: right;
}

/* ---------------- MOBILE VIEW ---------------- */
@media (max-width: 768px) {
  .desktop-text {
    display: none;
  }

  .mobile-text {
    display: block;
  }

  .nav-wrapper {
    justify-content: space-between;
  }
}

/* EXTRA SMALL */
@media (max-width: 400px) {
  .mobile-text {
    font-size: 11px;
  }
}
</style>
